module.exports = __webpack_public_path__ + "assets/19200addec6cf36f99cbefc3400f6067.json";